<template>
  <div>
    <v-toolbar flat>
      <v-toolbar-title>Precios</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="onRefresh"
      >
        <v-icon left>mdi-refresh</v-icon>
        Actualizar
      </v-btn>
      <v-btn
        :disabled="!$can('precios.store')"
        color="primary"
        @click="onCreate"
      >
        <v-icon left>mdi-plus</v-icon>
        Nuevo
      </v-btn>
    </v-toolbar>
    <v-sheet>
      <v-container>
        <precios-datatable></precios-datatable>
      </v-container>
    </v-sheet>
    <precios-create v-model="dialogCreate"></precios-create>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PreciosDatatable from '@/pages/precios/DatatableComponent'
import PreciosCreate from '@/pages/precios/CreateComponent'
export default {
  name: 'PreciosMainComponent',
  components: {
    'precios-datatable': PreciosDatatable,
    'precios-create': PreciosCreate,
  },
  data () {
    return {
      dialogCreate: false,
    }
  },
  computed: {
    //
  },
  methods: {
    ...mapActions('Precios', ['onFetch']),
    onCreate (event) {
      event.preventDefault()
      this.dialogCreate = true
    },
    onRefresh (event) {
      event.preventDefault()
      this.onFetch()
    }
  }
}
</script>
